import { ReactEditor } from 'slate-react';

export const withLinks = (editor: ReactEditor) => {
	const { isInline } = editor;
	// eslint-disable-next-line no-param-reassign
	editor.isInline = (element) => (element.type === 'link' ? true : isInline(element));
	return editor;
};
